import AppLoader from 'main/core/AppLoader';
import InventDash from 'pages/demo/InventDash';
import {useSelector} from 'react-redux';
import Dashboard from '.';

const DashboardSelector = () => {
  //   const currentUser = useSelector((state) => state.auth.user);
  const currentUser = useSelector(({memberReducer}) => memberReducer.authInfo);
  if (!currentUser) return <AppLoader />;

  switch (currentUser?.application) {
    case 'YS Inventory':
      return <InventDash />;
    default:
      return <Dashboard />;
  }
};

export default DashboardSelector;
